// extracted by mini-css-extract-plugin
module.exports = {"container":"Or_container__2nvhe","line":"Or_line__YeCi7"};